import { useState } from 'react';
import { Table } from '@flos/react-ui';
import { useHippoText } from '../../../../hooks/useHippoText';
import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import type { RowInformation } from '../../../../config/flavourConfig';
import TableRow from '../../../../shared_components/TableRow/TableRow';
import { getYoungPRCInsuranceSumsConfig } from './InsuranceSumsYoungPRCConfig';
import { getCoverableFromAllOnsaCoverables } from '../../../../utils/coverablesUtil';
import RemoveModal from '../../../../shared_components/RemoveModal/RemoveModal';
import HelpLink from '../../../../shared_components/HelpLink/HelpLink';

const InsuranceSumsPRCStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [coverables] = useRecoilState(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const youngPrcCoverable = coverables.youthContent ?? [];
    const coverableIndex = youngPrcCoverable?.findIndex(
        (coverable) => coverable.fixedId === currentProduct.fixedId
    );
    const currentYouthContentOnsa = youngPrcCoverable[coverableIndex];
    const componentProperties = getYoungPRCInsuranceSumsConfig(
        currentYouthContentOnsa,
        getHippoText
    );
    const coverableRows = componentProperties.rowsInformation;
    const [showRemoveModal, setShowRemoveModal] = useState<boolean>(false);
    const currentCoverable = getCoverableFromAllOnsaCoverables(
        coverables,
        currentProduct.fixedId,
        currentProduct.lobCode
    );

    return (
        <WizardPagetemplate onNext={goNext} onPrevious={goPrevious}>
            <CoverableDetailsTemplate
                header={getHippoText('DSS-COVERABLE-INFORMATION-STEP-SUMS-YOUNGPRC-HEADER')}
            >
                <Table mobileDirection="vertical" className="u-spacing-stack-sm">
                    <Table.Body>
                        {coverableRows.map((rowInfo: RowInformation) => {
                            return (
                                <TableRow
                                    key={rowInfo.key ?? rowInfo.name}
                                    rowInfo={rowInfo}
                                    shouldAlignTextLeftOnMobile
                                />
                            );
                        })}
                    </Table.Body>
                </Table>
            </CoverableDetailsTemplate>
            <HelpLink
                onClick={() => {
                    setShowRemoveModal(true);
                }}
            >
                {getHippoText('DSS-COVERABLE-INFORMATION-STEP-SUMS-INSURANCE-SUMS-YOUNG-TOO-LOW')}
            </HelpLink>
            {showRemoveModal && currentCoverable && (
                <RemoveModal
                    coverable={currentCoverable}
                    title={getHippoText('DSS-REMOVE-CONTINUE-MODAL-SUMS-TOO-LOW-HEADER')}
                    description={getHippoText('DSS-REMOVE-CONTINUE-MODAL-SUMS-TOO-LOW-SUBHEADER')}
                    isRemoveAndContinueModal
                    showModal={showRemoveModal}
                    showCloseButton
                    closeModal={() => {
                        setShowRemoveModal(false);
                    }}
                />
            )}
        </WizardPagetemplate>
    );
};

export default InsuranceSumsPRCStep;
